import Enumerable from "linq";
import { Point, Rectangle, Vector } from "../../../../domain/drawing";

export class StandardRelocator {
  relocatePoints(source: Point[], location: Point): Point[] {
    const offset = location.subtract(Rectangle.from(source).topLeft);
    return Enumerable.from(source)
      .select(p => p.add(offset))
      .toArray();
  }

  relocateRectangle(source: Rectangle, location: Point): Rectangle {
    return source.moveTo(location);
  }

  relocateVector(source: Vector, location: Point): Vector {
    return source.move(location.subtract(Rectangle.from(source).topLeft));
  }

  relocateVectorVertical(source: Vector, location: Point): Vector {
    const diff = location.subtract(Rectangle.from(source).topLeft);
    return source.move(new Point(0, diff.y));
  }
}
